import React from "react";

import { InfoPlate } from "fe-shared/src/components";
import { InvoiceStatusPlate } from "fe-shared-transactions/src/components";

import { Invoice } from "fe-shared-transactions/src/types";
import { formatInvoiceNumber } from "fe-shared-transactions/src/helpers/format";

import styles from "./InvoiceStatus.module.scss";

interface Props {
  invoice: Invoice;
}

const InvoiceStatus = ({ invoice }: Props) => {
  const { statusCode, invoiceNumber } = invoice;

  return (
    <div className={styles.header}>
      <div className={styles.status}>
        <InfoPlate variant="black" className={styles.statusInfoPlate}>
          {formatInvoiceNumber(invoiceNumber)}
        </InfoPlate>
        <InvoiceStatusPlate
          statusCode={statusCode}
          className={styles.statusInfoPlate}
        />
      </div>
    </div>
  );
};

export default InvoiceStatus;
